<template>
  <div class="w-full border border-2 p-1 rounded-lg h-[17rem]">
    <div class="d-flex gap-4">
      <div class="bg-[#FEF2CD] rounded py-[2px] px-[4px]">
        <span class="k-truck-fast text-[#D19D04] text-3xl" />
      </div>
      <span class="font-semibold align-self-center text-[16px] text-[#626262]">ORDERAN MASIH DIKIRIM</span>
      <span
        id="tooltip-on-send"
        class="k-info-circle align-self-center text-xl text-[#08A0F7]"
      />
      <b-tooltip
        target="tooltip-on-send"
        triggers="hover"
        variant="light"
      >
        <div class="text-start">
          <div class="mb-1">
            <b>Orderan Masih Dikirim</b>
          </div>
          <div>
            Total order dengan status order "Dikirim" (yang terkena tiket dan tidak terkena tiket) (berdasarkan filter yang dipilih)
          </div>
        </div>
      </b-tooltip>
    </div>
    <div class="d-flex gap-3 mt-1 pl-1">
      <div class="font-semibold text-3xl text-black">
        <b-spinner
          v-if="count === null"
          small
          variant="primary"
        />
        <span v-else>{{ count }}</span>
      </div>
      <div
        class="align-self-center py-[3px] px-[5px] bg-[#D9E7FD] text-[#4285F4] rounded-pill text-xs"
        style="border: solid 1px #4285F4"
      >
        <b-spinner
          v-if="countOfSend === null"
          small
          variant="info"
        />
        <span v-else>{{ percent }}</span>
        <span>% dari jumlah pengiriman</span>
      </div>
    </div>
    <div class="mt-1 px-1 text-[#828282]">
      <div class="d-flex justify-between">
        <div class="d-flex place-items-center">
          <div class="mr-1 p-[5px] w-[5px] h-[5px] rounded rounded-pill bg-[#BBE2C6]" />
          <span class="align-self-center">Tanpa Kendala</span>
        </div>
        <div class="font-semibold text-black">
          {{ noProblem }}
        </div>
      </div>
      <div class="d-flex justify-between">
        <div class="d-flex place-items-center">
          <div class="mr-1 p-[5px] w-[5px] h-[5px] rounded rounded-pill bg-[#FCBEBE]" />
          <span class="align-self-center">Kendala</span>
        </div>
        <div class="font-semibold text-black">
          {{ problem }}
        </div>
      </div>
    </div>
    <div class="w-full my-1">
      <b-button
        variant="primary"
        block
        @click="$router.push({ name: 'order-dikirim', params: { date: date } })"
      >
        <span class="k-danger text-[#FBBC05]" />
        <span class="mx-[5px]">Tinjauan Kendala Semua Ekspedisi</span>
        <span class="k-arrow-right-3 text-white" />
      </b-button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    countOfSend: {
      type: Number,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    shipping: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      count: null,
      percent: null,
      noProblem: null,
      problem: null,
    }
  },
  watch: {
    countOfSend(newVal) {
      if (newVal !== null) {
        this.getCount()
      }
    },
  },
  methods: {
    getCount() {
      const url = '/komship/api/v1/delivery-insight'
      const params = {
        metric: 'sent',
        date: this.date,
        shipping: this.shipping.shipping_name,
      }
      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.count = data.count
          this.noProblem = data.details[0].count
          this.problem = data.details[1].count
          this.percent = Number.isFinite(this.count / this.countOfSend)
            ? ((this.count / this.countOfSend) * 100).toFixed(2)
            : 0
        })
        .catch(res => {
          this.$toast_error({ message: 'Gagal Mendapatkan Data Orderan Masih Dikirim' })
        })
    },
  },
}
</script>
